(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8821],{

/***/ 29973:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), 'ArrowForward');

exports.Z = _default;

/***/ }),

/***/ 38628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ CMSChildrenContainer; },
  "Z": function() { return /* binding */ ChildrenContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./utils/stylesHelper.ts
// Future improvement could be to add baseClasses as a potential array - either array or string
// if (Array.isArray(baseClass)) { return [...baseClass, className].join(" ")
function combineClasses(baseClass, className) {
    return className ? "".concat(baseClass, " ").concat(className) : baseClass;
}

// EXTERNAL MODULE: ./components/CMS/ChildrenContainer/style.module.scss
var style_module = __webpack_require__(88460);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/CMS/ChildrenContainer/index.tsx




var CMSChildrenContainer = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: combineClasses((style_module_default()).childrenContainer, className),
        children: children
    });
};
/* harmony default export */ var ChildrenContainer = (CMSChildrenContainer);


/***/ }),

/***/ 88821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SingleCoverComponent": function() { return /* binding */ SingleCoverComponent; },
  "default": function() { return /* binding */ CMS_SingleCoverComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/CMS/ChildrenContainer/index.tsx + 1 modules
var ChildrenContainer = __webpack_require__(38628);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowForward.js
var ArrowForward = __webpack_require__(29973);
// EXTERNAL MODULE: ./components/Image/index.tsx + 2 modules
var Image = __webpack_require__(87113);
;// CONCATENATED MODULE: ./components/CMS/SingleCoverComponent/coverTypes.ts
var CoverStyle;
(function(CoverStyle) {
    CoverStyle["Center"] = "Center";
    CoverStyle["Left"] = "Left";
    CoverStyle["Right"] = "Right";
})(CoverStyle || (CoverStyle = {}));
var FontSize;
(function(FontSize) {
    FontSize["Small"] = "Small";
    FontSize["Large"] = "Large";
})(FontSize || (FontSize = {}));
var FontColour;
(function(FontColour) {
    FontColour["Light"] = "Light";
    FontColour["Dark"] = "Dark";
})(FontColour || (FontColour = {}));
var ColumnStyle;
(function(ColumnStyle) {
    ColumnStyle["FullSize"] = "Full_Width";
})(ColumnStyle || (ColumnStyle = {}));

// EXTERNAL MODULE: ./components/CMS/SingleCoverComponent/style.module.scss
var style_module = __webpack_require__(87878);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/CMS/SingleCoverComponent/index.tsx












var defaultUrl = "https://medworld-cdn-dev.s3.ap-southeast-2.amazonaws.com/medworld-app/smiling-female-doctor-default.webp";
var SingleCoverComponent = function(param) {
    var cover_collection = param.cover_collection, layout = param.layout, font_size = param.font_size, alignment = param.alignment, _font_colour = param.font_colour, font_colour = _font_colour === void 0 ? FontColour.Light : _font_colour;
    var isDesktop = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    if (!cover_collection) {
        // Don't render the SingleCoverComponent if the cover collection is missing.
        // This is expected, some CoverCollections in the CMS don't have all this data in them.
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var title = cover_collection.title, button_text = cover_collection.button_text, button_URL = cover_collection.button_URL, hyper_link = cover_collection.hyper_link, hyper_link_text = cover_collection.hyper_link_text, _button_style = cover_collection.button_style, button_style = _button_style === void 0 ? "Default" : _button_style;
    var _image;
    var image = (_image = cover_collection.image) !== null && _image !== void 0 ? _image : {
        url: defaultUrl,
        alternativeText: Image/* defaultAlt */.Zp
    };
    var _url;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (style_module_default()).container,
        children: [
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (style_module_default()).bgImageWrapper,
                children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: (_url = image.url) !== null && _url !== void 0 ? _url : defaultUrl,
                    layout: "fill",
                    className: (style_module_default()).bgImage,
                    alt: "",
                    priority: true,
                    sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 80vw, (max-width: 1920px) 70vw, (max-width: 2560px) 70vw, 1920px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (style_module_default()).coverLayout,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenContainer/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((style_module_default()).content, (style_module_default())[alignment], (style_module_default())[font_colour || FontColour.Light], (style_module_default())[layout]),
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: font_size === FontSize.Large ? "h4" : "h5",
                                className: (style_module_default()).title,
                                component: "h1",
                                children: title
                            }),
                            (button_URL || hyper_link) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()(alignment === CoverStyle.Center ? (style_module_default()).linkCenter : "", (style_module_default()).buttonContainer),
                                children: [
                                    button_URL && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (style_module_default()).button,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "contained",
                                            color: "secondary",
                                            href: button_URL,
                                            className: classnames_default()((style_module_default()).button, (style_module_default())[button_style]),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (style_module_default()).linkText,
                                                children: button_text
                                            })
                                        })
                                    }),
                                    hyper_link && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                        href: hyper_link,
                                        className: (style_module_default()).hyperLink,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (style_module_default())[font_colour],
                                                children: hyper_link_text
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                                className: (style_module_default())[font_colour]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var CMS_SingleCoverComponent = (SingleCoverComponent);


/***/ }),

/***/ 87113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mo": function() { return /* binding */ ImageContainer; },
  "Zp": function() { return /* binding */ defaultAlt; }
});

// UNUSED EXPORTS: RegisterImgStyle

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/SmallPrintTerms/style.module.scss
var style_module = __webpack_require__(10416);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/SmallPrintTerms/index.tsx





var SmallPrintTerms = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (style_module_default()).smallPrint,
        children: [
            "Our",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                as: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (style_module_default()).link,
                    href: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                    children: "Terms of Use"
                })
            }),
            " ",
            "and",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: path/* PATH.PRIVACY_POLICY */.m.PRIVACY_POLICY,
                as: path/* PATH.PRIVACY_POLICY */.m.PRIVACY_POLICY,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (style_module_default()).link,
                    href: path/* PATH.PRIVACY_POLICY */.m.PRIVACY_POLICY,
                    children: "Privacy Policy"
                })
            })
        ]
    });
};
/* harmony default export */ var components_SmallPrintTerms = (SmallPrintTerms);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
;// CONCATENATED MODULE: ./components/Image/img/quote.svg
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 52,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.79 46c-3.927 0-7.068-1.42-9.424-4.26C1.122 38.789 0 34.984 0 30.327c0-6.36 1.683-12.096 5.049-17.207C8.526 7.894 13.799 3.52 20.867 0l1.851 2.726c-3.365 2.044-6.45 4.94-9.255 8.689-2.693 3.634-4.039 7.326-4.039 11.074 0 1.022.28 1.874.841 2.555.561.568 1.403.852 2.525.852 2.804 0 5.16 1.023 7.068 3.067 2.019 1.93 3.029 4.316 3.029 7.155 0 2.84-1.01 5.225-3.03 7.156C17.95 45.091 15.595 46 12.79 46Zm29.113 0c-3.927 0-7.068-1.42-9.424-4.26-2.244-2.952-3.366-6.757-3.366-11.414 0-6.36 1.683-12.096 5.049-17.207C37.64 7.894 42.912 3.52 49.98 0l1.85 2.726c-3.365 2.044-6.45 4.94-9.255 8.689-2.693 3.634-4.039 7.326-4.039 11.074 0 1.022.28 1.874.842 2.555.56.568 1.402.852 2.524.852 2.805 0 5.16 1.023 7.068 3.067C50.99 30.893 52 33.279 52 36.118c0 2.84-1.01 5.225-3.03 7.156C47.065 45.091 44.709 46 41.904 46Z",
    fill: "#C0E8FF"
  })));
};
/* harmony default export */ var quote = (SvgQuote);
// EXTERNAL MODULE: ./components/Image/style.module.scss
var Image_style_module = __webpack_require__(20027);
var Image_style_module_default = /*#__PURE__*/__webpack_require__.n(Image_style_module);
;// CONCATENATED MODULE: ./components/Image/index.tsx
/* eslint-disable react/jsx-boolean-value */ 







var defaultAlt = "Medrecruit Image";
var convertToArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
var RegisterImgStyle;
(function(RegisterImgStyle) {
    RegisterImgStyle["Img"] = "img";
    RegisterImgStyle["OverlayImage"] = "overlayImage";
})(RegisterImgStyle || (RegisterImgStyle = {}));
var ImageContainer = function(param) {
    var img = param.img, imgStyle = param.imgStyle, imgAlt = param.imgAlt, overlayCenteredText = param.overlayCenteredText, overlayTextInBox = param.overlayTextInBox, width = param.width, height = param.height, whiteBackground = param.whiteBackground;
    var text = overlayCenteredText || overlayTextInBox;
    var textStyle = overlayCenteredText ? (Image_style_module_default()).centeredText : (Image_style_module_default()).overlayCenteredTextInBox;
    var termsStyle = overlayTextInBox ? (Image_style_module_default()).greyText : overlayCenteredText ? (Image_style_module_default()).hidden : (Image_style_module_default()).whiteText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Image_style_module_default()).imgContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()(imgStyle === RegisterImgStyle.OverlayImage ? (Image_style_module_default()).overlayImage : (Image_style_module_default()).img),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    priority: true,
                    width: width,
                    height: height,
                    src: img,
                    alt: imgAlt || defaultAlt,
                    title: imgAlt || defaultAlt
                })
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Image_style_module_default()).textContainer, textStyle, whiteBackground && (Image_style_module_default()).whiteBackground),
                children: [
                    overlayTextInBox && /*#__PURE__*/ (0,jsx_runtime.jsx)(quote, {}),
                    convertToArray(text).map(function(text, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: overlayCenteredText ? "h4" : index === 0 ? "subtitle1" : "caption",
                            display: "block",
                            component: "p",
                            children: text
                        }, "".concat(text, "-").concat(index));
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Image_style_module_default()).finePrint, termsStyle, whiteBackground && (Image_style_module_default()).paleBlueText),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SmallPrintTerms, {})
            })
        ]
    });
};


/***/ }),

/***/ 88460:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"childrenContainer":"style_childrenContainer__d3pAq"};

/***/ }),

/***/ 87878:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__ntyOE","title":"style_title__ejPcl","hyperLink":"style_hyperLink__wgM0q","bgImageWrapper":"style_bgImageWrapper__MWzPf","bgImage":"style_bgImage__SZu2P","coverLayout":"style_coverLayout__Ks3nr","content":"style_content__6xp5T","buttonContainer":"style_buttonContainer__qrsWg","Light":"style_Light__9zQku","Dark":"style_Dark__gnScJ","Center":"style_Center__IW3U7","Left":"style_Left__bj2cO","Full_Width":"style_Full_Width__XU1JN","Right":"style_Right__JJUVs","img":"style_img__djg53","linkText":"style_linkText__hJRos","button":"style_button___Xdkn","MainCTA":"style_MainCTA__DzOA7","linkCenter":"style_linkCenter__t00xv"};

/***/ }),

/***/ 20027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"style_imgContainer__okrSE","img":"style_img__XGlaq","overlayImage":"style_overlayImage__JBqLw","textContainer":"style_textContainer__Amkh2","centeredText":"style_centeredText__2FA7k","overlayCenteredTextInBox":"style_overlayCenteredTextInBox__Fudym","finePrint":"style_finePrint__Jzs6x","whiteText":"style_whiteText__k32cQ","greyText":"style_greyText__NEUAp","hidden":"style_hidden__EqpuW","centeredImg":"style_centeredImg__t2PIR","droplets":"style_droplets__Y3htk","whiteBackground":"style_whiteBackground__ByG1F","paleBlueText":"style_paleBlueText__yr_OJ"};

/***/ }),

/***/ 10416:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"smallPrint":"style_smallPrint__n1vZC"};

/***/ })

}]);